<template>
    <div>
        <notification-modal v-model:is-open="showReportModal" :is-error-modal="reportModalError">
            <template #title-content>
                {{ modalTitle }}
            </template>

            {{ modalMessage }}
        </notification-modal>
        <base-report>
            <h3 class="text-left text-lg font-semibold">Alarm Configuration Report</h3>
            <template #left-column>
                <div class="mb-4 lg:mb-12">
                    <p>
                        A printable table summarizing the alarm configuration of all visible points at this time,
                        which will highlight any issues Sonicu has automatically detected.
                    </p>
                </div>

                <div class="flex justify-center">
                    <button v-if="isRunning"
                            class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center
                            px-4 py-2 border border-transparent text-sm bg-blue-600 text-white font-medium py-2 px-4
                            rounded opacity-50 cursor-not-allowed">
                        <span class="lnr icon-loading animate-spin mr-3"></span>
                        Running Report, Please Wait
                    </button>
                    <button v-else
                            class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center px-4 py-2 border
                            border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600
                            hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700
                            active:bg-blue-700"
                            @click="runReport">
                        Run Report
                    </button>
                </div>
            </template>

            <template #right-column>
                <div></div>
            </template>
        </base-report>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import BaseReport from "./BaseReport"
import Select2 from "@/components/elements/select2"
import Toggle from "@/components/elements/toggle"
import DateTimePicker from "@/components/Reports/VueDatePicker";

import axios from "axios";
import NotificationModal from "@/components/elements/NotificationModal";

export default {
    name: "AlarmConfigurationReport",
    mixins: [SonicuCoreMixin],
    components: {NotificationModal, DateTimePicker, BaseReport, Select2, Toggle},
    props: {
    },
    data() {
        return {


            isSaving: false,
            isRunning: false,
            showReportModal: false,
            reportModalError: false,
            modalMessage: '',
            modalTitle: '',
            isErrorModal: false,
        }
    },
    created() {
    },
    mounted() {

    },
    methods: {
        runReport() {
            this.isRunning = true
            let formData = {}
            axios.post(this.company.buildCompanyRoute('reports/alarm-configuration-report'), formData)
                .then(response => {
                    this.modalTitle = 'Report Queued'
                    this.modalMessage = 'You will receive an email when the report is prepared.'
                    this.reportModalError = false
                    this.showReportModal = true
                })
                .catch(error => {
                    this.modalTitle = 'Report Error'
                    this.modalMessage = 'Error running report, please try again later.'
                    this.reportModalError = true
                    this.showReportModal = true
                })
                .finally(() => {
                    this.isRunning = false
                })

        },
    },
    watch: {
    },
    computed: {
    },
}
</script>

<style scoped>

</style>
